module.exports = __webpack_public_path__ + "media/voice-end.eb499157.mp3";